import React from 'react';
import { Box, Typography } from '@mui/material';
import FilePreview_ from './FilePreview.jsx';
import ReplyIcon from '@mui/icons-material/Reply';
import ReadReceipt from './ReadReceipt.jsx';

const ComprehensiveFileMessage = ({
  onJumpToOriginal,
  msg,
  isSentByUser,
  senderName,
  hoveredMessageId,
  setHoveredMessageId,
  HoverActions,
  setReplyToMessage,
  onForward,
  isLastRead,
  currentUser,
}) => {
  const sentDate = new Date(msg.sentAt);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isSentByUser ? 'flex-end' : 'flex-start',
        width: '100%',
        transition: 'all 0.2s ease',
        marginBottom: '16px'
      }}
    >
      <Box
        sx={{
          maxWidth: '45%',
          borderRadius: '12px',
          overflow: 'hidden',
          background: isSentByUser ? '#E0F2FE' : '#FFFFFF',
          color: '#1E293B',
          position: 'relative',
          border: '1px solid #E2E8F0',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={() => setHoveredMessageId(msg._id)}
        onMouseLeave={() => setHoveredMessageId(null)}
      >
        {/* Internal Header */}
        <Box sx={{ 
          px: '12px', 
          py: '4px', 
          background: isSentByUser ? 'rgba(0,0,0,0.04)' : 'rgba(0,0,0,0.02)',
          borderBottom: '1px solid rgba(0,0,0,0.05)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 4
        }}>
          <Typography sx={{ fontSize: '11px', fontWeight: 700, opacity: 0.9 }}>
            {isSentByUser ? 'Me' : senderName}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontSize: '9px', opacity: 0.7 }}>
              {sentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ px: '12px', py: '10px', position: 'relative' }}>
          {msg.isForwarded && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1, opacity: 0.6 }}>
               <Typography sx={{ fontSize: '10px', fontWeight: 700, fontStyle: 'italic' }}>
                 ➡️ Forwarded {msg.originalSender ? `from ${msg.originalSender}` : ""}
               </Typography>
            </Box>
          )}

          {hoveredMessageId === msg._id && (
            <Box sx={{ position: 'absolute', top: 2, right: 2, zIndex: 10, scale: '0.8' }}>
              <HoverActions
                message={{ ...msg, senderName }}
                onReply={setReplyToMessage}
                onForward={onForward}
              />
            </Box>
          )}

          {msg.isReply && (
            <Box
              onClick={(e) => { e.stopPropagation(); onJumpToOriginal(msg.replyTo); }}
              sx={{
                background: isSentByUser ? 'rgba(0,0,0,0.03)' : '#F8FAFD',
                borderRadius: '8px',
                padding: '8px 10px',
                marginBottom: '8px',
                borderLeft: `3px solid #60A5FA`,
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                cursor: 'pointer',
                '&:hover': { background: isSentByUser ? 'rgba(0,0,0,0.05)' : '#F1F5F9' }
              }}
            >
              <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#60A5FA', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                {msg.replyToSender || 'User'}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  color: '#475569',
                  fontStyle: 'italic',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  fontFamily: "'Inter', sans-serif"
                }}
              >
                {msg.replyToContent}
              </Typography>
            </Box>
          )}

          <Box sx={{ background: isSentByUser ? 'rgba(255,255,255,0.4)' : '#F8FAFD', borderRadius: '8px', padding: '10px', border: '1px solid rgba(0,0,0,0.05)', mb: 1 }}>
            <FilePreview_ file={msg.filetype} url={msg.fileUrl} fileName={msg.filename} msg={msg} />
          </Box>

          <Typography sx={{ fontSize: '10px', color: '#64748B', fontWeight: 600, mt: 0.5 }}>
            Shared {msg.filetype?.toUpperCase()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ComprehensiveFileMessage;